import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import Text from '../../text';

interface Props {
  children: ReactNode;
}

const FormSectionSubtitle: FC<Props> = ({ children }) => (
  <Box mb={2}>
    <Text size="medium" color="grey">
      {children}
    </Text>
  </Box>
);

export default FormSectionSubtitle;
